import { createContext } from "react";
import { observer } from "mobx-react-lite";
import SelfServiceController from "core/lib/self-service.controller";

export const SelfServiceContext = createContext(new SelfServiceController());

export const SelfServiceContextProvider = observer<any>(({ children, value }: { children: any, value: SelfServiceController }) => (
    <SelfServiceContext.Provider value={value}>{children}</SelfServiceContext.Provider>
));
